
























































































































































































import Vue from "vue";
import * as echarts from "echarts";
import "echarts-liquidfill";
import { getQueryVariable } from "../common/common";
import { mapState, mapActions } from "vuex";
import store from "../store/index";
// @ts-ignore
import i18n from "../language";

// // 模板文件不引入echarts
// import config from '../config/index';
// let echarts: any;
// if (config.env !== 'template') {
//   echarts = require('echarts');
//   require('echarts-liquidfill');
// }

export default Vue.extend({
	name: "CheckInfo",
	computed: mapState({
		checkInfo: (state: any) => store.getters.getCheckInfo,
		productId: (state: any) => store.getters.getProductId,
		reportType: (state: any) => store.getters.getReportType,
		checkType: (state: any) => store.getters.getCheckType,
		reportId: (state: any) => store.getters.getReportId,
	}),
	watch: {
		checkInfo(newQuestion, oldQuestion) {
			if (this.productId == "WFWBC") {
				this.checkInfo.reportModel.checkDBIds = [{ checkDBName: "批次互查", status: true }];
			}
			i18n.locale!== 'zh-CN' && this.initChart();
		},
	},
	data() {
		return {
			isCanDownload: true,
		};
	},
	methods: {
		toPercentageF(val: number) {
			return val.toFixed(4);
		},
		// 初始化图表
		initChart() {
			const container = document.getElementById("percentageChart");
			const chart = echarts.init(container as HTMLDivElement);
			(chart as any).setOption({
				title: {
					top: "56%",
					left: "center",
					subtext: (this as any).$t("info.allPerc"),
					subtextStyle: {
						color: "#F33C37",
						fontSize: 18,
					},
				},
				animation: false,
				series: [
					{
						type: "liquidFill",
						data: [this.toPercentageF(this.checkInfo.reportModel.copyPercent.totalCopyPercent || 0)],
						silent: true,
						color: ["#fac3c4"],
						radius: "80%",
						waveLength: "100%",
						amplitude: `${this.checkInfo.reportModel.copyPercent.totalCopyPercent === 1 || this.checkInfo.reportModel.copyPercent.totalCopyPercent === 0 ? "0" : "6"}%`,
						phase: 0,
						waveAnimation: false,
						itemStyle: {
							shadowBlur: 0,
						},
						outline: {
							borderDistance: 0,
							itemStyle: {
								borderWidth: 6,
								borderColor: "#fe9390",
							},
						},
						backgroundStyle: {
							color: "#fff",
						},
						label: {
							show: true,
							color: "#F33C37",
							insideColor: "#F33C37",
							fontSize: 50,
							fontWeight: "bold",
							align: "center",
							baseline: "middle",
							position: "inside",
							normal: {
								formatter(param: any) {
									return Math.round(param.value * 10000) / 100 + "%";
								},
								textStyle: {
									fontSize: 32,
									fontWeight: "bold",
								},
								color: "#F33C37",
								insideColor: "#F33C37",
								align: "center",
								baseline: "middle",
								position: "inside",
							},
						},
					},
				],
			});
		},
		// 获取ProductId reportId
		getProductId() {
			this.$store.dispatch("setProductId", getQueryVariable("productId"));
			this.$store.dispatch("setReportId", getQueryVariable("reportId"));
		},
		// 导出文件
		exportPostFiles(data: Blob, name: string) {
			const blob = new Blob([data], {
				type: "application/pdf",
			});
			const fileName = name;
			if ("download" in document.createElement("a") && (navigator as any).userAgent.indexOf("Edge") === -1) {
				// 非ie
				const ele = document.createElement("a");
				ele.download = fileName + ".pdf";
				ele.style.display = "none";
				ele.href = URL.createObjectURL(blob);
				document.body.appendChild(ele);
				ele.click();
				URL.revokeObjectURL(ele.href);
				document.body.removeChild(ele);
			} else {
				// ie
				navigator.msSaveBlob(blob, fileName + ".pdf");
			}
		},

		// 下载pdf
		downloadPDF() {
			this.$message({
				message: (this as any).$t("fOrH.downing"),
				type: "success",
			});
			if (!this.isCanDownload) {
				return false;
			}
			this.isCanDownload = false;
			// 报告类型
			const reportTypeRelation: any = {
				simple: (this as any).$t("app.simple"),
				originalText: (this as any).$t("app.origin"),
				detailPart: (this as any).$t("app.detail"),
				fullText: (this as any).$t("app.full"),
				preservation: (this as any).$t("app.preservation"),
				OneByOne: (this as any).$t("fOrH.oneReport"),
				simple_ft: (this as any).$t("app.simple"),
				originalText_ft: (this as any).$t("app.origin"),
				detailPart_ft: (this as any).$t("app.detail"),
				fullText_ft: (this as any).$t("app.full"),
				simple_en: (this as any).$t("app.simple") + ' report',
				originalText_en: (this as any).$t("app.origin") + ' report',
				detailPart_en: (this as any).$t("app.detail") + ' report',
				fullText_en: (this as any).$t("app.full") + ' report',
			};
			const reportType = reportTypeRelation[this.reportType] || (getQueryVariable("checkType") === "OneByOne" ? reportTypeRelation[this.checkType] : "");
			this.$http
				.post(
					"/api/ReportFile",
					{
						reportId: getQueryVariable("reportId"),
						productId: getQueryVariable("productId"),
						reportType: getQueryVariable("checkType") === "OneByOne" ? "one2One" : getQueryVariable("reportType"),
						checkTime: this.checkInfo.reportModel && this.checkInfo.reportModel.checkTime,
						checkType: getQueryVariable("checkType"),
					},
					{
						responseType: "blob",
					}
				)
				.then((res: any) => {
					this.isCanDownload = true;
					this.exportPostFiles(res.data, (this.checkInfo.reportModel && this.checkInfo.reportModel.title) + "（" + reportType + "）");
				});
		},
	},
	created() {
		this.getProductId();
	},
	mounted() {
		if (this.checkInfo.reportModel) {
			if (this.productId == "WFWBC") {
				this.checkInfo.reportModel.checkDBIds = [{ checkDBName: "批次互查", status: true }];
			}
			i18n.locale!== 'zh-CN' && this.initChart();
		}
	},
});
